import React, { useEffect, useContext, useRef } from 'react';
import { AuthContext } from '../context/AuthContext';

const InactivityTimer = ({ timeoutMinutes = 30 }) => {
  const { logout, token } = useContext(AuthContext);
  const timeoutRef = useRef(null);

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    // Set timeout to log out
    if (token) {
      timeoutRef.current = setTimeout(() => {
        logout();
        alert('Tu sesión ha expirado por inactividad.');
        window.location.href = '/login';
      }, timeoutMinutes * 60 * 1000);
    }
  };

  useEffect(() => {
    // Only set up listeners if user is logged in
    if (!token) return;

    // Events that indicate activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    const handleActivity = () => {
      resetTimer();
    };

    // Attach event listeners
    events.forEach(event => document.addEventListener(event, handleActivity));

    // Initialize timer
    resetTimer();

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach(event => document.removeEventListener(event, handleActivity));
    };
  }, [token, logout, timeoutMinutes]);

  return null; // This component doesn't render anything
};

export default InactivityTimer;
